<div class="mat-elevation-z8">
  <!-- Add Button -->
  <div class="filter-actions-line">
    @if(controlPermissions.addButton) {
      <button mat-raised-button color="primary" (click)="openSiteForm(true)" data-testId="btnAddSite">
        <mat-icon>add</mat-icon>
        <span>Add Site</span>
      </button>
    }
    <mat-form-field appearance="outline">
      <mat-label>Market</mat-label>
      <mat-select [(ngModel)]="selectedMarket"
                  data-testId="regions"
                  (selectionChange)="onMarketChange($event.value)">
        <div class="mat-select-search-container" (click)="$event.stopPropagation()">
          <input #marketSearchInput
                  matInput
                  placeholder="Search Market..."
                  (input)="filterMarkets($event)"
                  class="mat-select-search-input"
                  aria-label="Search Market" />
          <mat-icon class="mat-select-search-icon">search</mat-icon>
        </div>
        <mat-option *ngFor="let market of filteredMarkets" [value]="market.id">{{ market.regionName }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Site Type</mat-label>
      <mat-select [(ngModel)]="selectedSiteType"
                  data-testId="siteType"
                  (selectionChange)="onSiteTypeChange($event.value)">
        <mat-option [value]="null">-Select Site Type-</mat-option>
        <mat-option *ngFor="let type of siteTypes" [value]="type.id">
          {{ type.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="custom-search-box">
      <mat-icon>search</mat-icon>
      <input matInput [value]="filterText" (keyup)="applyFilter($event)" placeholder="Search..." />
    </div>
  </div>
  <!-- API Call Button -->
  <!-- <div class="form-grid p-10">
    <button
      mat-flat-button
      color="primary"
      (click)="fetchData()"
      [disabled]="!selectedMarket || !selectedSiteType"
    >
      Fetch Data
    </button>
  </div> -->
  <!-- Search Box -->
</div>
<div class="mat-elevation-z8 mar-top-20">
  <mat-card>
    <mat-card-content>
      <div class="gridheight clear-both viewport">
        <table mat-table
               [dataSource]="dataSource"
               class="mat-elevation-z8"
               multiTemplateDataRows
               matSort>
          <ng-container matColumnDef="expandIcon">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell
                *matCellDef="let element"
                style="
                width: 32px;
                border-right: 1px solid currentColor;
                padding-right: 24px;
                text-align: center;
              "></td>
          </ng-container>
          <ng-container matColumnDef="id">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Actions
            </th>
            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell
                *matHeaderCellDef
                class="mat-header-row actionwidth">
              Actions
            </th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                @if(controlPermissions.delete) {
                  <button (click)="openContextmenu(row, 'DELETE')" mat-menu-item style="color: red">
                    <mat-icon matListIcon color="warn">delete</mat-icon>
                    <span matLine>Delete </span>
                  </button>
                }
                <button mat-menu-item (click)="openContextmenu(row, 'EDIT')">
                  <mat-icon matListIcon>edit</mat-icon>
                  <span matLine>Edit </span>
                </button>
                <button mat-menu-item (click)="openContextmenu(row, 'ATTACH')">
                  <mat-icon matListIcon>attach_file</mat-icon>
                  <span matLine>Attach </span>
                </button>
                <button mat-menu-item
                        (click)="openContextmenu(row, 'VIEWDOC')"
                        [disabled]="row.loadSlip === 0"
                        [ngClass]="{ iconBGColor: row.loadSlip !== 0 }">
                  <mat-icon matListIcon>visibility</mat-icon>
                  <span matLine>View Attachment </span>
                </button>
              </mat-menu>
            </td>
          </ng-container>
          <ng-container matColumnDef="sid">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Site ID
            </th>
            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
          </ng-container>

          <ng-container matColumnDef="siteName">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Site
            </th>
            <td mat-cell *matCellDef="let element">{{ element.siteName }}</td>
          </ng-container>
          <ng-container matColumnDef="siteTypeName">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Site Type
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.siteTypeName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="isRevenue">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Is Revenue
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.isRevenue ? "Yes" : "No" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="isActive">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Active
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.isActive ? "Active" : "In-Active" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="address1">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Address Line1
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.address1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="address2">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Address Line2
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.address2 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="city">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              City
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.city }}
            </td>
          </ng-container>
          <ng-container matColumnDef="state">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              State
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.state }}
            </td>
          </ng-container>
          <ng-container matColumnDef="zipCode">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Zip Code
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.zipCode }}
            </td>
          </ng-container>
          <ng-container matColumnDef="regionNames">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Market
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.regionNames }}
            </td>
          </ng-container>
          <ng-container matColumnDef="contactName">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Contact Name
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.contactName }}
            </td>
          </ng-container>
          <ng-container matColumnDef="contactEmail">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Contact Email
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.contactEmail }}
            </td>
          </ng-container>
          <ng-container matColumnDef="contactNumber">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Contact Number
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.contactNumber }}
            </td>
          </ng-container>
          <ng-container matColumnDef="volume">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Volume
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.volume }}
            </td>
          </ng-container>
          <ng-container matColumnDef="manure_Goal">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Manure Goal
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.manure_Goal }}
            </td>
          </ng-container>
          <ng-container matColumnDef="ssO_Goal">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              SSO Goal
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.ssO_Goal }}
            </td>
          </ng-container>
          <ng-container matColumnDef="chP_Capacity">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              CHP Capacity
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.chP_Capacity }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cH4_Low_Heating_value">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row"
                style="min-width: 150px">
              CH4 Low Heating Value
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.cH4_Low_Heating_value }}
            </td>
          </ng-container>
          <ng-container matColumnDef="conversion_BTU">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Conversion BTU
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.conversion_BTU }}
            </td>
          </ng-container>
          <ng-container matColumnDef="normal_CHGP_Efficiency">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Normal CHGP Efficiency
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.normal_CHGP_Efficiency }}
            </td>
          </ng-container>
          <ng-container matColumnDef="specialInstructions">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Special Instructions
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.specialInstructions }}
            </td>
          </ng-container>
          <ng-container matColumnDef="disposalMethodNames">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Disposal Methods
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.disposalMethodNames }}
            </td>
          </ng-container>
          <ng-container matColumnDef="oracleAccountNumber">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Oracle Account Number
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.oracleAccountNumber }}
            </td>
          </ng-container>
          <ng-container matColumnDef="oracleSiteNumber">
            <th mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="mat-header-row">
              Oracle Site Number
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.oracleSiteNumber }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell"
                [attr.colspan]="displayedColumns.length"
                style="color: red; text-align: center; font-weight: 500">
              No data matching the filter.
            </td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
